import { UIVariantContext } from '../contexts/UIVariantContext'

/**
 * Whether this brand's accent (`clr(p-60)` / `clr(p-70)`) is dark enough to carry white ink and
 * to be read as link text: SoundGuys' blue is, Android Authority's green is not (it takes dark
 * ink, and links stay ink-coloured and underlined). The same split RWButton makes through
 * `UIVariantContext` — a palette fact, not a brand branch. Outside the provider (tests) = false.
 */
export function useDarkAccent(): boolean {
  return UIVariantContext.useOptionalContainer()?.colors === 'soundguys'
}
